import './style.scss';

addEventListener('DOMContentLoaded', function () {
    const calculatorContainer = document.querySelector('.lode--product-calculator');
    if (!calculatorContainer) return;

    const variantSelect = document.getElementById('calculator-variant');
    const measurementInput = document.getElementById('measurement-amount');
    const pricePerUnit = document.getElementById('price-per-unit');
    const totalPrice = document.getElementById('total-price');

    // Get product type and price from data attributes
    const isSimple = calculatorContainer.dataset.isSimple === 'true';
    const simplePrice = parseFloat(calculatorContainer.dataset.simplePrice || '0');

    // Auto-select first variation if available
    if (!isSimple && variantSelect && variantSelect.options.length > 1) {
        // Skip the first option (which is usually the placeholder)
        variantSelect.selectedIndex = 1;
    }

    // Function to update calculations
    function updateCalculations() {
        let price = 0;

        if (isSimple) {
            // For simple products, use the product-level calculator price
            price = simplePrice;
        } else {
            // For variable products, get price from selected variation
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            if (!selectedOption || !selectedOption.value) {
                pricePerUnit.textContent = '0,00';
                totalPrice.textContent = '0,00';
                return;
            }
            price = parseFloat(selectedOption.dataset.price);
        }

        const amount = parseFloat(measurementInput.value) || 0;

        // Update price per unit
        pricePerUnit.textContent = price.toFixed(2).replace('.', ',');

        // Calculate total
        const total = price * amount;
        totalPrice.textContent = total.toFixed(2).replace('.', ',');
    }

    // Add event listeners
    if (!isSimple && variantSelect) {
        variantSelect.addEventListener('change', updateCalculations);
    }
    if (measurementInput) {
        measurementInput.addEventListener('input', updateCalculations);
    }

    // Initialize calculations
    updateCalculations();
});